import { ApiService } from '@core/services/common';
import { API_ENDPOINT } from '@core/configs';
import { Injectable } from '@angular/core';
import { DeleteLiveRoleDTO } from '@core/models/dto/live-company.dto';

@Injectable({
  providedIn: 'root',
})
export class LiveCompanyService {
  constructor(private readonly http: ApiService) {
  }

  getAll() {
    return this.http.get(
      API_ENDPOINT.liveCompany.controller +
      API_ENDPOINT.liveCompany.getAll,
    );
  }

  getInfoSentLinked(organizationId: number, companyId: number) {
    return this.http.post(
      API_ENDPOINT.liveCompany.controller +
      API_ENDPOINT.liveCompany.getInfoSentLinked, { organizationId, companyId },
    );
  }

  deleteLiveRole(data: DeleteLiveRoleDTO) {
    return this.http.delete(
      API_ENDPOINT.liveCompany.controller +
      API_ENDPOINT.liveCompany.deleteLiveRole,
      data
    );
  }

  updatedXmlStatus() {
    return this.http.put(
      API_ENDPOINT.liveCompany.controller +
      API_ENDPOINT.liveCompany.updatedXmlStatus,
    );
  }
}
